import { RouterProvider } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { LoadingProvider } from '@/contexts/LoadingContext'
import { router } from '@/router'
import { Toaster } from '@/components/ui/toaster'
import '@/i18n'

function App() {
  return (
    <AuthProvider>
      <LoadingProvider>
        <RouterProvider router={router} />
        <Toaster />
      </LoadingProvider>
    </AuthProvider>
  )
}

export default App
